import { Component } from '@angular/core';

@Component({
  selector: 'lib-core-config',
  imports: [],
  templateUrl: './core-config.html',
  styleUrl: './core-config.css',
})
export class CoreConfig {}
